import TabBar from './bar'
import MainTab from './main'
import ResponsiveTab from './responsive'
import SummaryTab from './summary'
import AltSummaryTab from './alt-summary'

export default {
  TabBar,
  MainTab,
  ResponsiveTab,
  SummaryTab,
  AltSummaryTab
}



// WEBPACK FOOTER //
// ./src/styles/tabs/index.js